<style lang="scss" scoped>
.achievement {
    position: relative;
    height: 100%;
    padding-top: 128px;
    img {
        height: 160px;
        width: 160px;
        position: absolute;
        top: -60px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        object-fit: contain;
    }
    .description {
        opacity: 0.8;
    }
}
</style>

<template>
    <div class="bg-dark-blue rounded-28 px-24 pb-40 text-center flex flex-col justify-end achievement">
        <img v-if="data.acf.image" :data-src="data.acf.image.url" :alt="data.acf.image.alt" class="lazyload" style="top: -74px;" />
        <p class="text-24 mb-24 uppercase font-medium">{{ data.post_title }}</p>
        <p class="text-16 lg:text-24 mb-24 font-light description" v-html="nl2br(data.acf.intro)"></p>
        <a v-if="cta" :href="data.acf.intro_cta.url" class="text-darker-blue px-40 py-24 bg-white rounded-button border border-white transition-colors mx-auto inline-block">{{ data.acf.intro_cta.title }}</a>
    </div>

</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                acf: {
                    image: null,
                    intro: ""
                },
                post_title: ""
            })
        },
        cta: {
            required: false,
            type: Boolean
        }
    },
    methods: {
        nl2br(content) {
            if (!content) {
                return "";
            }
            return content.replace(/\n/g, "<br />");
        }
    }
};
</script>
